import _ from 'lodash'
export default function articles(state = [], action) {
  const newState = _.cloneDeep(state)

  switch (action.type) {    
    case 'GET_PRODUCTS_SUCCESS':
       return Object.assign({}, {}, {...state, message: '',  error: false, products: action.data})
    case 'GET_PRODUCT_SUCCESS':
       return Object.assign({}, {}, {...state, message: '',  error: false, product: action.data})
    case 'GET_PRODUCTS_FAILED':
        return Object.assign({}, newState, { message: 'error_getting_products',  error: action.data.error })
    case 'GET_PRODUCT_FAILED':
        return Object.assign({}, newState, { message: 'error_getting_product',  error: action.data.error })
    case 'RESET_STRIPE':
      return Object.assign({}, {}, {})
    default:
      return Object.assign({}, {}, { message: 'generic_fail_message',  error: true })
  }
}
